import { SessionState } from "@/store/session/state";

/**
 * Set the Session url string.
 * @param state - Vuex state for the session module.
 * @param value - string url.
 */
export function setSessionUrl(state: SessionState, value: string): void {
  state.sessionUrl = value;
}

/**
 * Set the Session isSidebarCollapsed value.
 * @param state - Vuex state for the session module.
 * @param value - boolean.
 */
export function setIsSidebarCollapsed(
  state: SessionState,
  value: boolean
): void {
  state.isSidebarCollapsed = value;
}
